import AntechLogo from "/assets/logos/Antech_Logo.jpg"
import IdexxLogo from "/assets/logos/IDEXX_Logo.jpg"
import ZoetisLogo from "/assets/logos/Zoetis_Logo.png"

export const services = [
  {
    title: "",
    description: "",
    icon: (
      <div className="rounded-3xlp-4 relative flex w-80 items-center justify-center">
        <img
          src={ZoetisLogo}
          className="relative z-10 h-full max-h-[200px] max-w-full object-contain"
          alt="Zoetis Logo"
        />
      </div>
    ),
  },
  {
    title: "",
    description: "",
    icon: (
      <div className="rounded-3xlp-4 relative flex w-80 items-center justify-center">
        <img
          src={AntechLogo}
          className="relative z-10 h-full max-h-[200px] max-w-full object-contain"
          alt="Antech Logo"
        />
      </div>
    ),
  },
  {
    title: "",
    description: "",
    icon: (
      <div className="rounded-3xlp-4 relative flex w-80 items-center justify-center">
        <img
          src={IdexxLogo}
          className="relative z-10 h-full max-h-[200px] max-w-full object-contain"
          alt="Idexx Logo"
        />
      </div>
    ),
  },
]
